/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Dispatch } from 'redux'
import { getCurrentMeetings, getPastMeetings } from '../../api/api'
import { Meeting } from '../../types/plann3r'

export const REQUEST_CURRENT_MEETINGS = 'REQUEST_CURRENT_MEETINGS'
export const RECEIVE_CURRENT_MEETINGS = 'RECEIVE_CURRENT_MEETINGS'
export const REQUEST_PAST_MEETINGS = 'REQUEST_PAST_MEETINGS'
export const RECEIVE_PAST_MEETINGS = 'RECEIVE_PAST_MEETINGS'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SET_HISTORY_PAGE = 'SET_HISTORY_PAGE'

export const requestCurrentMeetings = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: REQUEST_CURRENT_MEETINGS })

    dispatch(receiveCurrentMeetings(await getCurrentMeetings()))
  }
}

export const receiveCurrentMeetings = (meetings: Meeting[]) => {
  return {
    type: RECEIVE_CURRENT_MEETINGS,
    meetings: meetings,
  }
}

export const requestPastMeetings = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: REQUEST_PAST_MEETINGS })

    dispatch(receivePastMeetings(await getPastMeetings()))
  }
}

export const receivePastMeetings = (meetings: Meeting[]) => {
  return {
    type: RECEIVE_PAST_MEETINGS,
    meetings: meetings,
  }
}

export const setCurrentPage = (page: number) => {
  return {
    type: SET_CURRENT_PAGE,
    page,
  }
}

export const setHistoryPage = (page: number) => {
  return {
    type: SET_HISTORY_PAGE,
    page,
  }
}
